export default function Badge (props = {
    className: null,
    text: null,
    type: null
}) {
    return (
        <span
            className={`${`badge ${props.className || ''}`
                .trim()}${props.type
                    ? ` badge-${props.type}`
                    : ''}`}
            style={props.style || null}
        >
            {props.children || props.text || null}
        </span>
    )
}
